import React from "react"

import {
	NavigateFunction,
	useNavigate,
	useParams,
	useLocation,
	Location,
} from "react-router-dom"

export type UseRouterParams = {
	navigate: NavigateFunction,
	params: any,
	location: Location,
	searchParams: URLSearchParams,
}

/**
 * Utility per estrarre e parsare i query parameters dall'URL
 */
export const parseQueryParams = (search: string): Record<string, string> => {
	const params = new URLSearchParams(search)
	const result: Record<string, string> = {}
	
	params.forEach((value, key) => {
		result[key] = value
	})
	
	return result
}

/**
 * Utility per costruire query string da un oggetto
 */
export const buildQueryString = (params: Record<string, any>): string => {
	const searchParams = new URLSearchParams()
	
	Object.entries(params).forEach(([key, value]) => {
		if (value !== null && value !== undefined && value !== '') {
			searchParams.set(key, String(value))
		}
	})
	
	return searchParams.toString()
}

/**
 * HOC che fornisce funzionalità di routing estese inclusi query parameters
 */
const withUseRouter = (Component: React.ComponentType<any>) => {
	return (props: any) => {
		const navigate = useNavigate()
		const params = useParams()
		const location = useLocation()
		const searchParams = new URLSearchParams(location.search)
		
		return (
			<Component
				{...props}
				navigate={navigate}
				params={params}
				location={location}
				searchParams={searchParams}
			/>
		)
	}
}

export default withUseRouter
